module.exports = __webpack_public_path__ + "media/components/modals/login-background-28e74d13c8de74192c9aa486f59884ab.png";